import React from "react";
import { Box, Typography } from "@mui/material";
import RelatorioEstoqueHeader from "./relatorio_estoque_header";
import RelatorioEstoqueHeaderTable from "./relatorio_estoque_header_table";
import RelatorioEstoqueFooterTable from "./relatorio_estoque_footer";
import rows_example from "./relatorio_example";

import './relatorios.css'


const RelatorioEstoque = ({ rows, empresa }) => {


    //const rowss = rows_example

    const estoqueKey = empresa; // ex: "SO BA"
    const reservaKey = `reserva ${empresa}`;

    // Agrupar por ARO
    const aros = rows.reduce((acc, row) => {
        if (!acc[row.aro]) acc[row.aro] = [];
        acc[row.aro].push(row);
        return acc;
    }, {});

    const alturaPagina = 2100; // px úteis em A4
    const alturaLinha = document.querySelector(".relatorio-row")?.offsetHeight || 20;
    const linhasPorPagina = Math.floor(alturaPagina / alturaLinha);

    // transforma o objeto em array de tuplas (já deve estar assim pelo map que vc usa)
    const arosArray = Object.entries(aros);

    // achata ARO + produtos em uma lista linear de linhas
    const todosProdutos = arosArray.flatMap(([aro, produtos]) => {
        const produtosOrdenados = [...produtos].sort((a, b) =>
            a.GrupoSimilaridade.localeCompare(b.GrupoSimilaridade)
        );

        // Linha de título do ARO
        const linhaAro = { tipo: "aro", aro, produtos: produtosOrdenados };

        // Linhas de produtos
        const linhasProdutos = produtosOrdenados.map((p) => ({
            tipo: "produto",
            aro,
            produto: p,
        }));

        return [linhaAro, ...linhasProdutos];
    });

    // Quebra em páginas
    const paginas = [];
    for (let i = 0; i < todosProdutos.length; i += linhasPorPagina) {
        paginas.push(todosProdutos.slice(i, i + linhasPorPagina));
    }

    const dataAtualPTBR = () => {
        const now = new Date();
        const dia = String(now.getDate()).padStart(2, '0');
        const mes = String(now.getMonth() + 1).padStart(2, '0'); // meses vão de 0 a 11
        const ano = now.getFullYear();
        const hora = String(now.getHours()).padStart(2, '0');
        const minuto = String(now.getMinutes()).padStart(2, '0');

        return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
    }

    const data_agora = dataAtualPTBR();

    return (
        <>
            <Box className="relatorio-page">
                {paginas.map((pagina, paginaIndex) => {
                    // Calcula totais da página
                    const totalEstoqueFisico = rows.reduce(
                        (sum, row) => sum + (row[estoqueKey] || 0),
                        0
                    );

                    const totalEstoqueReserva = rows.reduce(
                        (sum, row) => sum + (row[reservaKey] || 0),
                        0
                    );

                    const totalEstoqueSaldo = totalEstoqueFisico - totalEstoqueReserva;

                    return (
                        <Box key={paginaIndex} className="relatorio-pagina">
                            <RelatorioEstoqueHeader
                                empresa={empresa}
                                data={data_agora}
                                sx={{ marginTop: paginaIndex > 0 ? "5rem" : "0" }}
                            />
                            <RelatorioEstoqueHeaderTable />

                            <Box className="relatorio-table">
                                {pagina.map((linha, idx) => {
                                    if (linha.tipo === "aro") {
                                        const totalFisico = linha.produtos.reduce(
                                            (sum, p) => sum + (p[estoqueKey] || 0),
                                            0
                                        );
                                        const totalReserva = linha.produtos.reduce(
                                            (sum, p) => sum + (p[reservaKey] || 0),
                                            0
                                        );
                                        const totalSaldo = totalFisico - totalReserva;

                                        return (
                                            <Box key={`aro-${idx}`} className="relatorio-row relatorio-row-aro">
                                                <Typography className="relatorio-col-codigo">{linha.aro}</Typography>
                                                <Typography className="relatorio-col-produto"></Typography>
                                                <Typography className="relatorio-col-fisico">{totalFisico}</Typography>
                                                <Typography className="relatorio-col-reserva">{totalReserva}</Typography>
                                                <Typography className="relatorio-col-saldo">{totalSaldo}</Typography>
                                            </Box>
                                        );
                                    }

                                    if (linha.tipo === "produto") {
                                        const p = linha.produto;
                                        const fisico = p[estoqueKey] || 0;
                                        const reserva = p[reservaKey] || 0;
                                        const saldo = fisico - reserva;

                                        return (
                                            <Box key={p.id} className="relatorio-row">
                                                <Typography className="relatorio-col-codigo">{p.id}</Typography>
                                                <Typography className="relatorio-col-produto">{p.Descricao}</Typography>
                                                <Typography className="relatorio-col-fisico">{fisico}</Typography>
                                                <Typography className="relatorio-col-reserva">{reserva}</Typography>
                                                <Typography className="relatorio-col-saldo">{saldo}</Typography>
                                            </Box>
                                        );
                                    }

                                    return null;
                                })}

                                {/* Renderiza o footer apenas na última página */}
                                {paginaIndex === paginas.length - 1 && (
                                    <RelatorioEstoqueFooterTable
                                        fisico={totalEstoqueFisico}
                                        reserv={totalEstoqueReserva}
                                        saldo={totalEstoqueSaldo}
                                    />
                                )}

                            </Box>
                        </Box>
                    );
                })}
            </Box>


        </>
    )
}

export default RelatorioEstoque